import { Home } from 'lucide-react';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card';

interface Address {
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
}

interface AddressFormProps {
  address: Address;
  onChange: (field: string, value: string) => void;
}

export function AddressForm({ address, onChange }: AddressFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Home className="h-5 w-5" />
          Home Address
        </CardTitle>
        <CardDescription>
          Your family's primary mailing address
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="street">Street Address</Label>
          <Input
            id="street"
            value={address.street || ''}
            onChange={(e) => onChange('street', e.target.value)}
            placeholder="123 Main Street"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="street2">Apt/Suite (optional)</Label>
          <Input
            id="street2"
            value={address.street2 || ''}
            onChange={(e) => onChange('street2', e.target.value)}
            placeholder="Apt 4B"
          />
        </div>
        <div className="grid grid-cols-6 gap-4">
          <div className="col-span-3 space-y-2">
            <Label htmlFor="city">City</Label>
            <Input
              id="city"
              value={address.city || ''}
              onChange={(e) => onChange('city', e.target.value)}
            />
          </div>
          <div className="col-span-1 space-y-2">
            <Label htmlFor="state">State</Label>
            <Input
              id="state"
              value={address.state || ''}
              onChange={(e) => onChange('state', e.target.value)}
              maxLength={2}
            />
          </div>
          <div className="col-span-2 space-y-2">
            <Label htmlFor="zip">ZIP Code</Label>
            <Input
              id="zip"
              value={address.zip || ''}
              onChange={(e) => onChange('zip', e.target.value)}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
